var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('h2',[_vm._v(_vm._s(_vm.__('Nenhum dado foi encontrado!')))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(this.content || _vm.__('Já tentou alterar as datas?')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }